import { ComponentType, FC } from 'react';

import {
  ApprovalProcessStatuses,
  EntityStatuses,
} from '../constants/shared.js';
import { EntitySpecificFields } from '../types/shared.js';
import ApproverPending from './statusBarVariants/ApproverPending.jsx';
import CommonVariant from './statusBarVariants/CommonVariant.jsx';
import RequesterDraft from './statusBarVariants/RequesterDraft.jsx';
import RequesterPending from './statusBarVariants/RequesterPending.jsx';
import RequesterRejected from './statusBarVariants/RequesterRejected.jsx';

type BaseProps = EntitySpecificFields & {
  approvalProcessId: string | null;
  userStatus: EntityStatuses;
  approvalProcessStatus: ApprovalProcessStatuses;
};

type ComponentMap = {
  [K in EntityStatuses]: {
    [P in ApprovalProcessStatuses]: ComponentType<BaseProps> | null;
  };
};

const APPROVAL_COMPONENT_MAP: ComponentMap = {
  requester: {
    draft: RequesterDraft,
    pending: RequesterPending,
    rejected: RequesterRejected,
    approved: CommonVariant,
  },
  approver: {
    draft: null,
    pending: ApproverPending,
    rejected: CommonVariant,
    approved: CommonVariant,
  },
  stranger: {
    draft: null,
    pending: CommonVariant,
    approved: CommonVariant,
    rejected: CommonVariant,
  },
};

const StatusBarRenderer: FC<BaseProps> = ({
  userStatus,
  approvalProcessStatus,
  approvalProcessId,
  entityType,
  entityId,
  entityName,
  entitySource,
  entityMetadata,
}) => {
  const Component = APPROVAL_COMPONENT_MAP[userStatus][approvalProcessStatus];

  if (!Component) {
    return null;
  }

  return (
    <Component
      userStatus={userStatus}
      approvalProcessId={approvalProcessId}
      approvalProcessStatus={approvalProcessStatus}
      entityType={entityType}
      entityId={entityId}
      entityName={entityName}
      entitySource={entitySource}
      entityMetadata={entityMetadata}
    />
  );
};

export default StatusBarRenderer;
